<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Unidade</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a @click="onCreate()" v-b-tooltip title="Cadastrar"
                      ><i
                        class="ft-plus"
                        v-if="getPermission('unidade.store')"
                      ></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onTeste()"
                      v-b-tooltip
                      title="Testar Alerta GR"
                      v-if="getPermission('unidade.status')"
                      ><i class="fa fa-plus-square"></i
                    ></a>
                  </li>

                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermission('unidade.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inativar Registros"
                      v-if="getPermission('unidade.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/unidade"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="unidade_id"
                    pagination-path=""
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:cell-clicked="onDetail"
                    detail-row-component="unidade-detalhes"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-if="getPermission('unidade.update')"
                          v-b-tooltip
                          title="Editar"
                          ><i class="fa fa-edit"></i
                        ></a>
                        <a
                          v-if="props.rowData.status.valor == 2"
                          @click="onActivateDesactivate(1, props.rowData, true)"
                          v-b-tooltip
                          title="Ativar"
                          ><i class="fa fa-thumbs-o-up"></i
                        ></a>
                        <a
                          v-if="props.rowData.status.valor == 1"
                          @click="onActivateDesactivate(2, props.rowData, true)"
                          v-b-tooltip
                          title="Inativar"
                          ><i class="fa fa-thumbs-o-down"></i
                        ></a>
                        <a
                          @click="onCreateDoc(props.rowData, props.rowIndex)"
                          v-if="getPermission('unidade.documento.store')"
                          v-b-tooltip
                          title="Vincular Documento"
                          ><i class="fa fa-file"></i
                        ></a>
                        <a
                          @click="onCreateConta(props.rowData, props.rowIndex)"
                          v-if="getPermission('unidade.conta.store')"
                          v-b-tooltip
                          title="Vincular Conta"
                          ><i class="fa fa-money"></i
                        ></a>
                        <a
                          @click="onIntegration(props.rowData.unidade_id)"
                          v-b-tooltip
                          title="Integrar Gestão de pagamento"
                          ><i class="fa fa-credit-card"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <UnidadeForm ref="unidadeform" />
      <VincularContaUnidadeForm ref="vincularcontaunidadeform" />
      <VincularDocumentoUnidadeForm ref="vinculardocumentounidadeform" />
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import UnidadeFilterBar from "./UnidadeFilterBar";
import UnidadeDetalhes from "./UnidadeDetalhes";
import UnidadeForm from "./UnidadeForm";
import VincularContaUnidadeForm from "./VincularContaUnidadeForm.vue";
import VincularDocumentoUnidadeForm from "./VincularDocumentoUnidadeForm.vue";
import moment from "moment";

Vue.component("unidade-detalhes", UnidadeDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    UnidadeForm,
    VincularContaUnidadeForm,
    VincularDocumentoUnidadeForm,
    "vuetable-filterbar": UnidadeFilterBar,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalDoc: false,
      showModalConta: false,
      isFullscreen: false,
      optionsLivStatus: [],
      optionsLivStatusDoc: [],
      optionsLivTpPrefixoNumControle: [],
      optionsDoc: [],
      optionsLivTpUnidade: [],
      optionsLivTipoCte: [],
      optionsMunicipio: [],
      optionsTpQuebraUc: [],
      optionsTpRateio: [],
      optionsParamBanco: [],
      optionsTpRegraMontagem: [],
      optionsExigeCteMontagem: [],
      optionsBloqueiaExpedicao: [],
      optionsValidaAjudante: [],
      optionsValidaNfsCanceladas: [],
      optionsTpProcesso: [],
      optionsParamBloqueiaOcorrencia: [],
      optionsTriagem: [],
      optionsModuloConferencia: [],
      optionsTpAtividade: [],
      optionsCalculoTipoCarga: [],
      optionsLivPrincipal: [],
      optionsLivStatusConta: [],
      optionsTpExpedicao: [],
      optionsVersaoDacte: [],
      optionsParamTipoServico: [],
      tpQuebraUcSelected: [],
      tpRateioSelected: [],
      optionsRotaOtimizacao: [],
      optionsRotaMenorTempo: [],
      optionsRotaMenorDistancia: [],
      optionsRotaPreferenciaRodovia: [],
      optionsRotaEvitarPedagio: [],
      optionsRotaEvitarBalsa: [],
      optionsRotaEvitarEstradaTerra: [],
      optionsRestringirTempo8h: [],
      optionsRestringirHorarioComercial: [],
      optionsRestringirHorarioPontoParada: [],
      optionsRestringirZonaCirculacaoSp: [],
      optionsRestringirZonaRodizio: [],
      optionsRestringirZonasLogisticas: [],
      optionsAvisoVencimento: [],
      helpForm: new Form({ statusRecord: [], status: "", unidade_id: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "cd",
          title: "Código",
          sortField: "cd",
        },
        {
          name: "tp_unidade.descr",
          title: "Tipo Unidade",
          sortField: "tp_unidade",
        },
        {
          name: "descr",
          title: "Descrição",
          sortField: "descr",
        },
        {
          name: "horario_tz",
          title: "Fuso Horário",
          sortField: "horario_tz",
        },
        {
          name: "liv_tipo_cte.descr",
          title: "CTE",
          sortField: "liv_tipo_cte.descr",
        },
        {
          name: "tp_atividade.descr",
          title: "Tipo Atividade",
          sortField: "tp_atividade.descr",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
      optionsIntegracaoNotasPorManifesto: [],
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function (data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        cd: data_filter.cd,
        descr: data_filter.descr,
        cnpj: data_filter.cnpj,
        razao_social: data_filter.razao_social,
        tp_unidade: data_filter.tp_unidade.value,
        status: data_filter.status.value,
        tipo_doc: data_filter.tipo_doc.value,
        municipio: data_filter.municipio.value,
      };
      Vue.nextTick(() => this.$refs.vuetable.reload());
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.unidade_id);
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.unidade_id);
      }
    },
    onCreate() {
      this.$refs.unidadeform.onCreate();
    },
    onEdit(data, index) {
      this.$refs.unidadeform.onEdit(data);
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    handleOkDoc(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStoreDoc();
      } else {
        this.onUpdateDoc(this.formdoc.unidoc_id);
      }
    },
    handleOkConta(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStoreConta();
      } else {
        this.onUpdateConta(this.form_conta.unicon_id);
      }
    },
    onTeste() {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm
        .post("/api/unidade/testealertagr")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onIntegration(id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.unidade_id = id;
      this.helpForm
        .post("/api/unidade/gestaopagamento")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onCreateDoc(data, index) {
      this.$refs.vinculardocumentounidadeform.onCreate(data);
    },
    onCreateConta(data, index) {
      this.$refs.vincularcontaunidadeform.onCreate(data);
    },
    onEditDoc(data, index) {
      this.$refs.vinculardocumentounidadeform.onEdit(data);
    },
    onEditConta(data, index) {
      this.$refs.vincularcontaunidadeform.onEdit(data);
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/unidade/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/unidade/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/unidade/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach((obj) => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });

          response.tp_unidade.forEach((obj) => {
            this.optionsLivTpUnidade.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.versao_cte.forEach((obj) => {
            this.optionsLivTipoCte.push({ label: obj.descr, value: obj.valor });
          });

          response.municipio.forEach((obj) => {
            this.optionsMunicipio.push({
              label: obj.nome,
              value: obj.municipio_id,
              ibge: obj.cd_ibge,
            });
          });

          response.status_doc.forEach((obj) => {
            this.optionsLivStatusDoc.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_prefixo_num_controle.forEach((obj) => {
            this.optionsLivTpPrefixoNumControle.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.param_tp_doc.forEach((obj) => {
            this.optionsDoc.push({ label: obj.descr, value: obj.partipdoc_id });
          });

          response.param_banco.forEach((obj) => {
            this.optionsParamBanco.push({
              label: obj.descr,
              value: obj.parban_id,
            });
          });

          response.status_conta.forEach((obj) => {
            this.optionsLivStatusConta.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.principal.forEach((obj) => {
            this.optionsLivPrincipal.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_regra_montagem.forEach((obj) => {
            this.optionsTpRegraMontagem.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.exige_cte_montagem_carga.forEach((obj) => {
            this.optionsExigeCteMontagem.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.bloqueia_expedicao.forEach((obj) => {
            this.optionsBloqueiaExpedicao.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.valida_ajudante.forEach((obj) => {
            this.optionsValidaAjudante.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.valida_nfs_canceladas.forEach((obj) => {
            this.optionsValidaNfsCanceladas.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.calculo_tipo_carga.forEach((obj) => {
            this.optionsCalculoTipoCarga.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_quebra_uc.forEach((obj) => {
            this.optionsTpQuebraUc.push({ label: obj.descr, value: obj.valor });
          });
          response.tp_rateio.forEach((obj) => {
            this.optionsTpRateio.push({ label: obj.descr, value: obj.valor });
          });
          response.versao_dacte.forEach((obj) => {
            this.optionsVersaoDacte.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_expedicao_transp.forEach((obj) => {
            this.optionsTpExpedicao.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.rota_otimizacao.forEach((obj) => {
            this.optionsRotaOtimizacao.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.rota_evitar_pedagio.forEach((obj) => {
            this.optionsRotaEvitarPedagio.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.rota_evitar_balsa.forEach((obj) => {
            this.optionsRotaEvitarBalsa.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.rota_evitar_estrada_terra.forEach((obj) => {
            this.optionsRotaEvitarEstradaTerra.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.restringir_tempo_8h.forEach((obj) => {
            this.optionsRestringirTempo8h.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.restringir_horario_comercial.forEach((obj) => {
            this.optionsRestringirHorarioComercial.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.restringir_horario_ponto_parada.forEach((obj) => {
            this.optionsRestringirHorarioPontoParada.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.restringir_zona_circulacao_sp.forEach((obj) => {
            this.optionsRestringirZonaCirculacaoSp.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.restringir_zona_rodizio.forEach((obj) => {
            this.optionsRestringirZonaRodizio.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.restringir_zonas_logisticas.forEach((obj) => {
            this.optionsRestringirZonasLogisticas.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.param_bloqueia_ocorrencia.forEach((obj) => {
            this.optionsParamBloqueiaOcorrencia.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.triagem.forEach((obj) => {
            this.optionsTriagem.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.utiliza_modulo_conferencia.forEach((obj) => {
            this.optionsModuloConferencia.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_atividade.forEach((obj) => {
            this.optionsTpAtividade.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_processo.forEach((obj) => {
            this.optionsTpProcesso.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.integracao_notas_por_manifesto.forEach((obj) => {
            this.optionsIntegracaoNotasPorManifesto.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.aviso_vencimento.forEach((obj) => {
            this.optionsAvisoVencimento.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.param_tipo_servico.forEach((obj) => {
            this.optionsParamTipoServico.push({ label: obj.descr, value: obj.partpserv_id });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({
          id: data.unidade_id,
          status: action,
        });
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push({ id: obj, status: action });
        });
      }
      this.$refs.unidadeform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
<style>
.form-check {
  padding: 0 1.25rem;
}
</style>
